function formatRelative(isoString) {
  if (!isoString) return '—';
  const ms = Date.now() - new Date(isoString).getTime();
  const mins = Math.floor(ms / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

function StatusBadge({ status }) {
  const map = {
    success: 'bg-emerald-50 text-emerald-700',
    failed: 'bg-red-50 text-red-600',
    running: 'bg-blue-50 text-blue-700',
    pending: 'bg-gray-100 text-gray-500',
  };
  const icons = {
    success: '✓',
    failed: '✗',
    running: '↻',
    pending: '…',
  };
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-1.5 py-0.5 rounded ${map[status] ?? 'bg-gray-100 text-gray-500'}`}>
      <span className={status === 'running' ? 'animate-spin inline-block' : ''}>{icons[status] ?? '?'}</span>
      {status}
    </span>
  );
}

export default function ETLJobHistory({ jobs, loading }) {
  if (loading && jobs.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
        <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">Recent Jobs</h2>
        <div className="space-y-2">
          {[1, 2, 3].map(i => (
            <div key={i} className="h-8 bg-gray-100 rounded animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm">
      <h2 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3">Recent Jobs</h2>
      {jobs.length === 0 ? (
        <p className="text-sm text-gray-400">No jobs yet. Trigger a run to get started.</p>
      ) : (
        <div className="divide-y divide-gray-50">
          {jobs.slice(0, 8).map(job => (
            <div key={job.job_id} className="py-2 flex items-center gap-2">
              <StatusBadge status={job.status} />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-mono text-gray-700 truncate">
                  {job.ocel_file ?? `job-${job.job_id}`}
                </div>
                {job.error && (
                  <div className="text-xs text-red-500 truncate">{job.error}</div>
                )}
              </div>
              <div className="text-right flex-shrink-0">
                {job.ocel_event_count != null && (
                  <div className="text-xs text-gray-500">{job.ocel_event_count.toLocaleString()} ev</div>
                )}
                {job.status === 'success' && !job.rows_extracted && (
                  <div className="text-xs text-amber-600">extraction skipped</div>
                )}
                <div className="text-xs text-gray-400">{formatRelative(job.started_at)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
